export default "__VITE_ASSET__WZdcsfz0__"